import {inject, injectable} from "inversify";
import type {IUser, IUpdateUserData} from "data/stores/user/user.store";
import type {IApiResponse, IHttpClientService} from "data/services/http";
import type {AxiosResponse} from "axios";
import {Bindings} from "data/constants/bindings";
import {AbstractApiProvider} from "data/providers/api/abstract.api.provider";

export interface ILoginPayload {
	email: string;
	password: string;
}

type TLoginResponse = IApiResponse<{user: IUser}>;

export interface IProfile {
	marketingOptInPickem: boolean;
	isNotificationsEnabled?: boolean;
	terms: boolean;
	marketingEmails?: boolean;
}

type IProfileResponse = IApiResponse<{profile: IProfile}>;
type ICountryResponse = IApiResponse<{country: string}>;

export interface IAuthApiProvider {
	login: (params: ILoginPayload) => Promise<AxiosResponse<TLoginResponse>>;
	logout: () => Promise<AxiosResponse>;
	update: (data: IUpdateUserData) => Promise<AxiosResponse<IProfileResponse>>;
	fetchUser: () => Promise<AxiosResponse<TLoginResponse>>;
	fetchUserProfile: () => Promise<AxiosResponse<IProfileResponse>>;
	fetchUserCountry: () => Promise<AxiosResponse<ICountryResponse>>;
}

@injectable()
export class AuthApiProvider extends AbstractApiProvider implements IAuthApiProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {
		super();
	}

	login = (params: ILoginPayload) => this._http.post<TLoginResponse>("auth/landing", params);

	logout = () => this._http.post(`${this.language}/auth/logout`);

	fetchUser = () => this._http.get<TLoginResponse>(`${this.language}/user`);

	fetchUserProfile = () => this._http.get<IProfileResponse>(`${this.language}/profile`);

	update = (data: IUpdateUserData) =>
		this._http.post<IProfileResponse>(`${this.language}/profile/save`, data);

	fetchUserCountry = () => this._http.get<ICountryResponse>(`${this.language}/user/country`);
}
